import Joi from "joi"

export const EMPLOYEE_CENTER_FORM_KEYS = {
    FIRST_NAME:"firstName",
    LAST_NAME:"lastName",
    EMAIL:"email",
    DEPARTMENT:"department"
}
const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

export const employeeCenterSchema = Joi.object({
    [EMPLOYEE_CENTER_FORM_KEYS.FIRST_NAME]: Joi.string().label('First Name').required().trim().messages({
        "string.pattern.base": "First Name is required"
    }),
    [EMPLOYEE_CENTER_FORM_KEYS.LAST_NAME]: Joi.string().label('Last Name').required().trim().messages({
        "string.pattern.base": "Last Name is required"
    }),
    [EMPLOYEE_CENTER_FORM_KEYS.EMAIL]: Joi.string().label('Email').regex(emailRegex).required().trim().messages({
        "string.pattern.base": "\"Email\" is required in valid format"
    }),
    [EMPLOYEE_CENTER_FORM_KEYS.DEPARTMENT]: Joi.string().label('Department').required().trim().messages({
        "string.pattern.base": "Department is required"
    })
})